// extracted by mini-css-extract-plugin
export default {"chart-wrapper":"index_chart-wrapper__+E18Z","chartWrapper":"index_chart-wrapper__+E18Z","chart-loader":"index_chart-loader__V8igV","chartLoader":"index_chart-loader__V8igV"};